import { useEffect } from "react";
import {
  React,
  Heading,
  Button,
  Subtitle,
  Shortcut,
  // Steps
} from "mondrian-react";

import "./style.scss";
import { onLinkIsClicked } from "./actions.js";
import { isMobile } from "react-device-detect";
import useIsTotem from "hooks/useIsTotem";
import { reportGA4, reportPageViewGA4 } from "utils/pushDataLayer";

const PhoneError = ({ handleButtonClick, msisdn, currentStep }) => {
  currentStep = 3
  const [steps, setSteps] = React.useState([
    {
      title: "Celular",
      status: "doing",
    },
    {
      title: isMobile ? "Código" : "Código de segurança",
      status: "todo",
    },
    {
      title: "Faturas",
      status: "todo",
    },
  ]);

  const isTotem = useIsTotem();

  useEffect(() => {
    reportPageViewGA4({customTitle: 'erro_validacao_do_numero'})
  }, [])

  React.useEffect(() => {
    let newStepsState = [];
    steps.forEach((_step, index) => {
      if (currentStep > index) {
        newStepsState.push({
          ..._step,
          status: "active",
        });
      } else if (currentStep === index) {
        newStepsState.push({
          ..._step,
          status: "doing",
        });
      } else {
        newStepsState.push({
          ..._step,
          status: "todo",
        });
      }
    });
    setSteps(newStepsState);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [currentStep]);
  return (
    <div>
      <i className={"mdn-Icon-claro mdn-Icon--lg mcm-iconClaro"}></i>
      <Heading xs className="mcm-TitleEmpty">
        Número {msisdn} não encontrado.
      </Heading>
      <Subtitle xs className="mcm-SubTitleEmpty">
        Por favor, verifique e tente novamente
      </Subtitle>
      <Button onClick={() => {
        handleButtonClick()
        reportGA4({customTitle: 'erro_validacao_do_numero:tentar_novamente'})
      }} 
      className="mcm-backButton">
        Tentar novamente
      </Button>
      {!isTotem &&
        <>
          <Heading xs className="mcm-MoreInfo">
            Para mais informações acesse os canais:
          </Heading>
          <Shortcut
            onClick={() => {
              onLinkIsClicked()
              reportGA4({customTitle: 'erro_validacao_do_numero:minha_claro_movel'})
            }}
            icon={"mdn-Shortcut-icon mdn-Icon-documento mdn-Icon--md"}
            inverse
            className="mcm-Cardlink"
          >
            Minha Claro móvel
          </Shortcut>
        </>
      }
    </div>
  );
};

export default PhoneError;
